const LIST_TEMPLATE_DEFAULT = [
    {
        id: 3,
        name: '3',
        image_preview: '/images/landingpage/preview_template/prv_3.png'
    },
    {
        id: 4,
        name: '4',
        image_preview: '/images/landingpage/preview_template/prv_4.png'
    },
    {
        id: 5,
        name: '5',
        image_preview: '/images/landingpage/preview_template/prv_5.jpg'
    },
    {
        id: 6,
        name: '6',
        image_preview: '/images/landingpage/preview_template/prv_6.jpg'
    },
    {
        id: 7,
        name: '7',
        image_preview: '/images/landingpage/preview_template/prv_7.png'
    },
    {
        id: 8,
        name: '8',
        image_preview: '/images/landingpage/preview_template/prv_8.png'
    }
];

const HANDLE_MAP_STYLE_WITH_DEFAULT = (listStyle) => {
    return listStyle.filter((item) => LIST_TEMPLATE_DEFAULT.map((df) => df.id).includes(item.id));
};

const LIST_STYLE_TIME = HANDLE_MAP_STYLE_WITH_DEFAULT([
    {
        id: 3,
        name: '3',
        contents: `
        <div id="boxTimeApp" class="box--time">
            <div class="__3">
                <h2 id="shotTitle" class="time-title">《タイトル》</h2>
                <div class="time-content">
                    <div id="shotStartTime" class="time-desc">《開始》</div>
                    <div class="arrow-right"></div>
                    <div id="shotEndTime" class="time-desc">《終了》</div>
                </div>
            </div>
        </div>
        `,
        cssStyle: `
        .box--time .__3 {
            background: #A4B4DC;
            padding: 40px 40px 50px;
            color: #5D6B8F;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            gap: 40px;
            align-items: center;
            border: 3px dotted #AB7572;
        }
        .box--time .__3 .time-title {
            font-size: 24px;
            margin: 0 auto;
            width: fit-content;
            text-align: center;
            background: #5D6B8F;
            color: #fff;
            padding: 10px 20px;
            border-radius: 8px;
        }
        .box--time .__3 .arrow-right {
            width: 0;
            height: 0;
            border-top: 20px solid #5D6B8F;
            border-right: 20px solid transparent;
            border-left: 20px solid transparent;
        }
        .box--time .__3 .time-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            }
        .box--time .__3 .time-desc {
            font-size: 20px;
        }
        `
    },
    {
        id: 4,
        name: '4',
        contents: `
        <div id="boxTimeApp" class="box--time">
            <div class="__4">
                <h2 id="shotTitle" class="time-title">《タイトル》</h2>
                <div class="time-content">
                    <div id="shotStartTime" class="time-desc">《開始》</div>
                    <div class="arrow-right"></div>
                    <div id="shotEndTime" class="time-desc">《終了》</div>
                </div>
            </div>
        </div>
        `,
        cssStyle: `
        .box--time .__4 {
            background: #fff;
            padding: 40px 40px 50px;
            font-weight: bold;
            display: grid;
            grid-template-columns: 200px 1fr;
            justify-content: space-between;
            gap: 40px;
            align-items: center;
            border-top: 8px solid #FF87F5;
            border-bottom: 8px solid #FF87F5;
            position: relative;
            box-sizing: border-box;
        }
        .box--time .__4::before {
            content: '';
            position: absolute;
            inset: -16px 0 -16px 0;
            border-top: 8px solid #947BE8;
            border-bottom: 8px solid #947BE8;
            z-index: -1;
        }
        .box--time .__4 .time-title {
            font-size: 4vw;
            margin: 0 auto;
            width: 100%;
            aspect-ratio: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            background: #947BE8;
            color: #fff;
            padding: 20px;
            border-radius: 999px;
        }
        .box--time .__4 .arrow-right {
            width: 0;
            height: 0;
            border-top: 20px solid #947BE8;
            border-right: 20px solid transparent;
            border-left: 20px solid transparent;
        }
        .box--time .__4 .time-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
        }
        .box--time .__4 .time-desc {
            font-size: 30px;
            -webkit-text-stroke: 2px #947BE8;
            background: #fff;
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            letter-spacing: -1px;
        }
        `
    },
    {
        id: 5,
        name: '5',
        contents: `
        <div id="boxTimeApp" class="box--time">
            <div class="__5">
                <h2 id="shotTitle" class="time-title">《タイトル》</h2>
                <div class="time-content">
                    <div id="shotStartTime" class="time-desc">《開始》</div>
                    <div class="arrow-right"></div>
                    <div id="shotEndTime" class="time-desc">《終了》</div>
                </div>
            </div>
        </div>
        `,
        cssStyle: `
        .box--time .__5 {
        background: linear-gradient(to right, #4b7ed7, #b84ba2);
        padding: 40px 40px 50px;
        color: #fff;
        font-weight: bold;
        }
        .box--time .__5 .time-title {
            position: relative;
            font-size: 42px;
            margin: 0 auto;
            margin-bottom: 50px;
            width: fit-content;
            text-align: center;
        }
        .box--time .__5 .time-title::after {
            position: absolute;
            content: '';
            bottom: -10px;
            width: 110%;
            left: 50%;
            transform: translateX(-50%);
            height: 1px;
            background-color: #fff;
        }
        .box--time .__5 .arrow-right {
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid white;
        }
        .box--time .__5 .time-content {
            display: grid;
            grid-template-columns: 1fr 20px 1fr;
            gap: 30px;
            justify-items: center;
        }
        .box--time .__5 .time-desc {
            font-size: 40px;
        }
        `
    },
    {
        id: 6,
        name: '6',
        contents: `
        <div id="boxTimeApp" class="box--time">
            <div class="__6">
                <h2 id="shotTitle" class="time-title">《タイトル》</h2>
                <div class="time-content">
                    <div id="shotStartTime" class="time-desc">《開始》</div>
                    <div class="arrow-right"></div>
                    <div id="shotEndTime" class="time-desc">《終了》</div>
                </div>
            </div>
        </div>
        `,
        cssStyle: `
        .box--time .__6 {
            background: #FECE01;
            padding: 40px 40px 50px;
            font-weight: bold;
        }
        .box--time .__6 .time-title {
            position: relative;
            font-size: 42px;
            margin: 0 auto;
            margin-bottom: 50px;
            width: fit-content;
            text-align: center;
        }
        .box--time .__6 .time-title::after {
            position: absolute;
            content: '';
            bottom: -10px;
            width: 110%;
            left: 50%;
            transform: translateX(-50%);
            height: 1px;
            background-color: #000;
        }
        .box--time .__6 .arrow-right {
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid #000000;
        }
        .box--time .__6 .time-content {
            display: grid;
            grid-template-columns: 1fr 20px 1fr;
            gap: 30px;
            justify-items: center;
        }
        .box--time .__6 .time-desc {
            font-size: 56px;
            text-align: center;
        }
        `
    },
    {
        id: 7,
        name: '7',
        contents: `
        <div id="boxTimeApp" class="box--time">
            <div class="__7">
                <h2 id="shotTitle" class="time-title">《タイトル》</h2>
                <div class="time-content">
                    <div id="shotStartTime" class="time-desc">《開始》</div>
                    <div class="arrow-right"></div>
                    <div id="shotEndTime" class="time-desc">《終了》</div>
                </div>
            </div>
        </div>
        `,
        cssStyle: `
        .box--time .__7 {
            background: #333;
            padding: 40px 40px 50px;
            font-weight: bold;
            border-radius: 9999px;
            margin: 0 25px;
            color: #ffffff;
        }
        .box--time .__7 .time-title {
            position: relative;
            font-size: 42px;
            margin: 0 auto;
            margin-bottom: 50px;
            width: fit-content;
            text-align: center;
        }
        .box--time .__7 .arrow-right {
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid #FFF;
        }
        .box--time .__7 .time-content {
            display: grid;
            grid-template-columns: 1fr 20px 1fr;
            gap: 30px;
            justify-items: center;
        }
        .box--time .__7 .time-desc {
            font-size: 56px;
            text-align: center;
        }
        `
    },
    {
        id: 8,
        name: '8',
        contents: `
        <div id="boxTimeApp" class="box--time">
            <div class="__8">
                <h2 id="shotTitle" class="time-title">《タイトル》</h2>
                <div class="time-content">
                    <div id="shotStartTime" class="time-desc">《開始》</div>
                    <div class="arrow-right"></div>
                    <div id="shotEndTime" class="time-desc">《終了》</div>
                </div>
            </div>
        </div>
        `,
        cssStyle: `
        .box--time .__8 {
        background: linear-gradient(to right, #231F20, #0C1779, #231F20);
        padding: 40px 40px 50px;
        color: #fff;
        font-weight: bold;
        }
        .box--time .__8 .time-title {
            position: relative;
            font-size: 42px;
            margin: 0 auto;
            margin-bottom: 50px;
            width: fit-content;
            text-align: center;
        }
        .box--time .__8 .arrow-right {
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid white;
        }
        .box--time .__8 .time-content {
            display: grid;
            grid-template-columns: 1fr 20px 1fr;
            gap: 30px;
            justify-items: center;
        }
        .box--time .__8 .time-desc {
            font-size: 40px;
        }
        `
    }
]);

const LIST_STYLE_PRIZE = HANDLE_MAP_STYLE_WITH_DEFAULT([
    {
        id: 3,
        name: '3',
        backgroundColorDefault: '#F5BEBB',
        contents: `
         <div style="display: 《display》;" class="prize-item">
            <div class="prize-box" style="background-color: 《backgroundItem》">
                <div class="prize-title" style="font-size: 《fontSizePrize》;color: 《colorPrize》;background: 《bgrColorPrize》; ">《タイトル》</div>
                <div class="prize-img"><img src="《imgTitle》" alt="" /></div>
                <div class="prize-content item-center">
                    <div class="prize-desc">《詳細》</div>
                    <div class="prize-name">《当選人数》</div>
                </div>
            </div>
        </div>`
    },
    {
        id: 4,
        name: '4',
        backgroundColorDefault: '#DEC2FF',
        contents: `
         <div style="display: 《display》;" class="prize-item">
            <div class="prize-box" style="background-color: 《backgroundItem》">
                <div class="prize-title" style="font-size: 《fontSizePrize》;color: 《colorPrize》;background: 《bgrColorPrize》; ">《タイトル》</div>
                <div class="prize-img"><img src="《imgTitle》" alt="" /></div>
                <div class="prize-content item-center">
                    <div class="prize-name">《当選人数》</div>
                    <div class="prize-desc">《詳細》</div>
                </div>
            </div>
        </div>`
    },
    {
        id: 5,
        name: '5',
        backgroundColorDefault: '#000',
        contents: `
         <div style="display: 《display》;" class="prize-item">
            <div class="prize-title" style="font-size: 《fontSizePrize》;color: 《colorPrize》;background: 《bgrColorPrize》; ">《タイトル》</div>
            <div class="prize-box" style="background-color: 《backgroundItem》">
                <div class="prize-img"><img src="《imgTitle》" alt="" /></div>
                <div class="prize-content item-center">
                    <div class="prize-desc">《詳細》</div>
                    <div class="prize-name">《当選人数》</div>
                </div>
            </div>
        </div>`
    },
    {
        id: 6,
        name: '6',
        backgroundColorDefault: '#ffffff',
        contents: `
        <div style="display: 《display;" class="prize-item">
        <div class="prize-box" style="background-color: 《backgroundItem》">
                <div class="prize-title" style="font-size: 《fontSizePrize》;color: 《colorPrize》;background: 《bgrColorPrize》; ">《タイトル》</div>
                <div class="prize-img"><img src="《imgTitle》" alt="" /></div>
                <div class="prize-content item-center">
                    <div class="prize-desc">《詳細》</div>
                    <div class="prize-name">《当選人数》</div>
                </div>
        </div>`
    },
    {
        id: 7,
        name: '7',
        backgroundColorDefault: '#D5E020',
        contents: `
         <div style="display: 《display》;" class="prize-item">
            <div class="prize-box" style="background-color: 《backgroundItem》">
                <div class="prize-title" style="font-size: 《fontSizePrize》;color: 《colorPrize》;background: 《bgrColorPrize》; ">《タイトル》</div>
                <div class="prize-img"><img src="《imgTitle》" alt="" /></div>
                <div class="prize-content item-center">
                    <div class="prize-desc">《詳細》</div>
                    <div class="prize-name">《当選人数》</div>
                </div>
            </div>
        </div>`
    },
    {
        id: 8,
        name: '8',
        backgroundColorDefault: '#ffffff',
        contents: `
         <div style="display: 《display》;" class="prize-item">
            <div class="prize-box" style="background-color: 《backgroundItem》">
                <div class="prize-title" style="font-size: 《fontSizePrize》;color: 《colorPrize》;background: 《bgrColorPrize》; ">《タイトル》</div>
                <div class="prize-img"><img src="《imgTitle》" alt="" /></div>
                <div class="prize-content item-center">
                    <div class="prize-desc">《詳細》</div>
                    <div class="prize-name">《当選人数》</div>
                </div>
            </div>
        </div>`
    }
]);

const LIST_STYLE_TARGET_PRODUCT = HANDLE_MAP_STYLE_WITH_DEFAULT([
    {
        id: 3,
        name: '3',
        backgroundColorDefault: '#F5BEBB',
        contents: `
        <div style="display: 《display》" class="target_product-item">
        <div class="target_product-box" style="background-color: 《backgroundItem》">
            <div class="target_product-title" style="font-size: 《fontSizeProduct》;color: 《colorProduct》;background: 《bgrColorProduct》; ">《nameTargetProduct》</div>
                <div class="target_product-img"><img src="《imageTargetProduct》"alt="《imageTargetProduct》"/></div>
                <div class="target_product-content item-center">
                    <div class="target_product-desc">《detailTargetProduct》</div>
                </div>
            </div>
        </div>
        `
    },
    {
        id: 4,
        name: '4',
        backgroundColorDefault: '#DEC2FF',
        contents: `
        <div style="display: 《display》" class="target_product-item">
        <div class="target_product-box" style="background-color: 《backgroundItem》">
            <div class="target_product-title" style="font-size: 《fontSizeProduct》;color: 《colorProduct》;background: 《bgrColorProduct》; ">《nameTargetProduct》</div>
                <div class="target_product-img"><img src="《imageTargetProduct》"alt="《imageTargetProduct》"/></div>
                <div class="target_product-content item-center">
                    <div class="target_product-desc">《detailTargetProduct》</div>
                </div>
            </div>
        </div>
        `
    },
    {
        id: 5,
        name: '5',
        backgroundColorDefault: '#000',
        contents: `
        <div style="display: 《display》" class="target_product-item">
            <div class="target_product-title" style="font-size: 《fontSizeProduct》;color: 《colorProduct》;background: 《bgrColorProduct》; ">《nameTargetProduct》</div>
            <div class="target_product-box" style="background-color: 《backgroundItem》">
                <div class="target_product-img"><img src="《imageTargetProduct》"alt="《imageTargetProduct》"/></div>
                <div class="target_product-content item-center">
                    <div class="target_product-desc">《detailTargetProduct》</div>
                </div>
            </div>
        </div>
        `
    },
    {
        id: 6,
        name: '6',
        backgroundColorDefault: '#ffffff',
        contents: `
        <div style="display: 《display》" class="target_product-item">
        <div class="target_product-box" style="background-color: 《backgroundItem》">
                <div class="target_product-title" style="font-size: 《fontSizeProduct》;color: 《colorProduct》;background: 《bgrColorProduct》; ">《nameTargetProduct》</div>
                <div class="target_product-img"><img src="《imageTargetProduct》"alt="《imageTargetProduct》"/></div>
                <div class="target_product-content item-center">
                    <div class="target_product-desc">《detailTargetProduct》</div>
                </div>
            </div>
        </div>
        `
    },
    {
        id: 7,
        name: '7',
        backgroundColorDefault: '#D5E020',
        contents: `
        <div style="display: 《display》" class="target_product-item">
        <div class="target_product-box" style="background-color: 《backgroundItem》">
            <div class="target_product-title" style="font-size: 《fontSizeProduct》;color: 《colorProduct》;background: 《bgrColorProduct》; ">《nameTargetProduct》</div>
                <div class="target_product-img"><img src="《imageTargetProduct》"alt="《imageTargetProduct》"/></div>
                <div class="target_product-content item-center">
                    <div class="target_product-desc">《detailTargetProduct》</div>
                </div>
            </div>
        </div>
        `
    },
    {
        id: 8,
        name: '8',
        backgroundColorDefault: '#ffffff',
        contents: `
        <div style="display: 《display》" class="target_product-item">
        <div class="target_product-box" style="background-color: 《backgroundItem》">
            <div class="target_product-title" style="font-size: 《fontSizeProduct》;color: 《colorProduct》;background: 《bgrColorProduct》; ">《nameTargetProduct》</div>
                <div class="target_product-img"><img src="《imageTargetProduct》"alt="《imageTargetProduct》"/></div>
                <div class="target_product-content item-center">
                    <div class="target_product-desc">《detailTargetProduct》</div>
                </div>
            </div>
        </div>
        `
    }
]);

const LIST_STYLE_APPLICATION_METHODS = HANDLE_MAP_STYLE_WITH_DEFAULT([
    {
        id: 3,
        name: '3',
        backgroundColorDefault: '#F5BEBB',
        colorDefault: '#000000',
        stepJoin: `<div style="display: 《display》" class="step-icon-arrow"><svg width="885" height="40" viewBox="0 0 885 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.6" d="M884.822 2.5H516.753L442.411 24.0448L368.069 2.5H1.90735e-06" stroke="#A4B4DC" stroke-width="5" stroke-miterlimit="10"/>
        <path opacity="0.6" d="M884.822 15.2104H516.753L442.411 36.495L368.069 15.2104H0" stroke="#A4B4DC" stroke-width="5" stroke-miterlimit="10"/>
        </svg>
        </div>`,
        contents: `
        <div style="display: 《display》;background-color: 《backgroundItem》" class="step-item">
                <div class="step-title"  style="font-size: 《fontSizeMethod》;color: 《colorMethod》;background: 《bgrColorMethod》; ">《タイトル》</div>
                <div class="step-img"><img src="《imgTitle》" alt="《imgTitle》" /></div>
                <div class="step-desc">《詳細》</div>
            </div>`
    },
    {
        id: 4,
        name: '4',
        backgroundColorDefault: '#DEC2FF',
        colorDefault: '#000000',
        stepJoin: `<div style="display: 《display》" class="step-icon-arrow"></div>`,
        contents: `
        <div style="display: 《display》;background-color: 《backgroundItem》" class="step-item">
                <div class="step-title"  style="font-size: 《fontSizeMethod》;color: 《colorMethod》;background: 《bgrColorMethod》; ">《タイトル》</div>
                <div class="step-img"><img src="《imgTitle》" alt="《imgTitle》" /></div>
                <div class="step-desc">《詳細》</div>
            </div>`
    },
    {
        id: 5,
        name: '5',
        backgroundColorDefault: '#ffffff',
        colorDefault: '#ffffff',
        stepJoin: `<div style="display: 《display》" class="step-icon-arrow"></div>`,
        contents: `
        <div style="display: 《display》;background-color: 《backgroundItem》" class="step-item">
                <div class="step-title title-decor"  style="font-size: 《fontSizeMethod》;color: 《colorMethod》;background: 《bgrColorMethod》; ">《タイトル》</div>
                <div class="step-img"><img src="《imgTitle》" alt="《imgTitle》" /></div>
                <div class="step-desc">《詳細》</div>
            </div>`
    },
    {
        id: 6,
        name: '6',
        backgroundColorDefault: '#fece01',
        colorDefault: '#000000',
        stepJoin: `<div style="display: 《display》" class="step-icon-arrow"></div>`,
        contents: `
          <div style="display: 《display》;background-color: 《backgroundItem》" class="step-item">
                <div class="step-title" style="font-size: 《fontSizeMethod》;color: 《colorMethod》;background: 《bgrColorMethod》; ">《タイトル》</div>
                <div class="step-img"><img src="《imgTitle》" alt="《imgTitle》" /></div>
                <div class="step-desc">《詳細》</div>
            </div>`
    },
    {
        id: 7,
        name: '7',
        backgroundColorDefault: '#D5E020',
        colorDefault: '#000000',
        stepJoin: ``,
        contents: `
        <div style="display: 《display》;background-color: 《backgroundItem》" class="step-item">
                <div class="step-title" style="font-size: 《fontSizeMethod》;color: 《colorMethod》;background: 《bgrColorMethod》; ">《タイトル》</div>
                <div class="step-img"><img src="《imgTitle》" alt="《imgTitle》" /></div>
                <div class="step-desc">《詳細》</div>
            </div>`
    },
    {
        id: 8,
        name: '8',
        backgroundColorDefault: '#ffffff',
        colorDefault: '#000000',
        stepJoin: `<div style="display: 《display》" class="step-icon-arrow"></div>`,
        contents: `
        <div style="display: 《display》;background-color: 《backgroundItem》" class="step-item">
                <div class="step-title"  style="font-size: 《fontSizeMethod》;color: 《colorMethod》;background: 《bgrColorMethod》; ">《タイトル》</div>
                <div class="step-img"><img src="《imgTitle》" alt="《imgTitle》" /></div>
                <div class="step-desc">《詳細》</div>
            </div>`
    }
]);

const LIST_STYLE_APPLICATION_RULE = HANDLE_MAP_STYLE_WITH_DEFAULT([
    {
        id: 3,
        name: '3',
        backgroundColorDefault: '#F5BEBB'
    },
    {
        id: 4,
        name: '4',
        backgroundColorDefault: '#DEC2FF'
    },
    {
        id: 5,
        name: '5',
        backgroundColorDefault: '#000000'
    },
    {
        id: 6,
        name: '6',
        backgroundColorDefault: '#000000'
    },
    {
        id: 7,
        name: '7',
        backgroundColorDefault: '#D5E020'
    },
    {
        id: 8,
        name: '8',
        backgroundColorDefault: '#ffffff'
    }
]);

const LIST_STYLE_CONTACT = HANDLE_MAP_STYLE_WITH_DEFAULT([
    {
        id: 3,
        name: '3',
        backgroundColorDefault: '#F5BEBB',
        contents: `
         <div class="inquiry-box">
                <div id="shotCompany" class="inquiry-desc">《お問い合わせ事務局名》<br />キャンペーン専用窓口</div>
                <div id="shotPhone" class="inquiry-number">《TEL》</div>
                <div id="shotTime" class="inquiry-desc">受付時間: 00:00~00:00 <br />(祝日を除く月~金曜日)</div>
            </div>
        `,
        cssStyle: `
        .inquiry {
            padding: 260px 50px 200px;
        }
        .inquiry-box {
            background-color: #fff;
            color: #AB7572;
            padding: 100px 40px;
        }
        .inquiry-desc {
            font-size: 28px;
            text-align: center;
        }
        .inquiry-number {
            margin: 40px auto;
            font-size: 45px;
            width: fit-content;
            -webkit-text-stroke: 2px #ED9898;
            background: #fff;
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }`
    },
    {
        id: 4,
        name: '4',
        backgroundColorDefault: '#DEC2FF',
        contents: `
         <div class="inquiry-box">
                <div id="shotCompany" class="inquiry-desc">《お問い合わせ事務局名》<br />キャンペーン専用窓口</div>
                <div id="shotPhone" class="inquiry-number">《TEL》</div>
                <div id="shotTime" class="inquiry-desc">受付時間: 00:00~00:00 <br />(祝日を除く月~金曜日)</div>
            </div>
        `,
        cssStyle: `
        .inquiry {
            padding: 260px 50px 200px;
        }
        .inquiry-box {
            background-color: #fff;
            color: #000;
            padding: 100px 40px;
        }
        .inquiry-desc {
            font-size: 32px;
            text-align: center;
        }
        .inquiry-number {
            margin: 40px auto;
            font-size: 68px;
            font-weight: bold;
            width: fit-content;
            -webkit-text-stroke: 2px #947BE8;
            background: #fff;
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }`
    },
    {
        id: 5,
        name: '5',
        contents: `
         <div class="inquiry-box">
                <div id="shotCompany" class="inquiry-desc">《お問い合わせ事務局名》<br />キャンペーン専用窓口</div>
                <div id="shotPhone" class="inquiry-number">《TEL》</div>
                <div id="shotTime" class="inquiry-desc">受付時間: 00:00~00:00 <br />(祝日を除く月~金曜日)</div>
            </div>
        `,
        cssStyle: `
        .inquiry {
            background-color: #fff;
            padding: 260px 50px 200px;
        }
        .inquiry-box {
            background-color: #000;
            color: #fff;
            padding: 100px 40px;
        }
        .inquiry-desc {
            font-size: 32px;
            text-align: center;
        }
        .inquiry-number {
            margin: 40px auto;
            font-size: 68px;
            width: fit-content;
            -webkit-text-stroke: 2px #fff;
            background: linear-gradient(to right, #4b7ed7, #b84ba2);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }`
    },
    {
        id: 6,
        name: '6',
        backgroundColorDefault: '#FECE01',
        colorDefault: '',
        contents: `
         <div class="inquiry-box">
                <div id="shotCompany" class="inquiry-desc">《お問い合わせ事務局名》<br />キャンペーン専用窓口</div>
                <div id="shotPhone" class="inquiry-number">《TEL》</div>
                <div id="shotTime" class="inquiry-desc">受付時間: 00:00~00:00 <br />(祝日を除く月~金曜日)</div>
            </div>
        `,
        cssStyle: `
        .inquiry {
            padding: 260px 50px 200px;
        }
        .inquiry .title-common .title-eng{
            background: #fff;
        }
        .inquiry-box {
            background-color: #000;
            color: #fff;
            padding: 100px 40px;
        }
        .inquiry-desc {
            font-size: 32px;
            text-align: center;
        }
        .inquiry-number {
            margin: 40px auto;
            font-size: 68px;
            width: fit-content;
            color: #FECE01;
        }`
    },
    {
        id: 7,
        name: '7',
        backgroundColorDefault: '#D5E020',
        colorDefault: '',
        contents: `
         <div class="inquiry-box">
                <div id="shotCompany" class="inquiry-desc">《お問い合わせ事務局名》<br />キャンペーン専用窓口</div>
                <div id="shotPhone" class="inquiry-number">《TEL》</div>
                <div id="shotTime" class="inquiry-desc">受付時間: 00:00~00:00 <br />(祝日を除く月~金曜日)</div>
            </div>
        `,
        cssStyle: `
        .inquiry {
            background-color: #D5E020;
            padding: 260px 50px 200px;
        }
        .inquiry-box {
            background-color: #fff;
            color: #000;
            padding: 100px 40px;
            border-radius: 12px;
        }
        .inquiry-desc {
            font-size: 32px;
            text-align: center;
        }
        .inquiry-number {
            margin: 40px auto;
            font-size: 68px;
            width: fit-content;
            padding-bottom: 10px;
            border-bottom: 1px solid #333;
        }`
    },
    {
        id: 8,
        name: '8',
        contents: `
         <div class="inquiry-box">
            <div id="shotCompany" class="inquiry-desc">《お問い合わせ事務局名》<br />キャンペーン専用窓口</div>
            <div id="shotPhone" class="inquiry-number">《TEL》</div>
            <div id="shotTime" class="inquiry-desc">受付時間: 00:00~00:00 <br />(祝日を除く月~金曜日)</div>
        </div>
        `,
        cssStyle: `
        .inquiry {
            background-color: #fff;
            padding: 260px 50px 200px;
        }
        .inquiry-box {
            background: linear-gradient(to right, #231F20, #0C1779);
            color: #fff;
            padding: 100px 40px;
        }
        .inquiry-desc {
            font-size: 32px;
            text-align: center;
        }
        .inquiry-number {
            margin: 40px auto;
            font-size: 68px;
            width: fit-content;
        }`
    }
]);

const LIST_STYLE_BUTTON_BLOCK = HANDLE_MAP_STYLE_WITH_DEFAULT([
    {
        id: 3,
        name: '3',
        backgroundColorDefault: '#414041',
        colorDefault: '#F7C0BD',
        contents: `
        <a id="button-link" href="《URL》" target="_blank" class="button--type__3" style="color:《color》;font-family:《fontFamily》;background-color:《backgroundColor》;">
                <p style="font-family:《fontFamily》;">《titleButton》</p><span style="color:《color》;" class="arrow-right"></span>
        </a>`
    },
    {
        id: 4,
        name: '4',
        backgroundColorDefault: '#FFFB5F',
        colorDefault: '#947BE8',
        contents: `
        <a id="button-link" href="《URL》" target="_blank" class="button--type__3" style="color:《color》;font-family:《fontFamily》;background-color:《backgroundColor》;">
                <p style="font-family:《fontFamily》;">《titleButton》</p><span style="color:《color》;" class="arrow-right"></span>
        </a>`
    },
    {
        id: 5,
        name: '5',
        backgroundColorDefault: '#b84ba2',
        colorDefault: '#ffffff',
        contents: `
        <a id="button-link" href="《URL》" target="_blank" class="button--type__5" style="color:《color》;font-family:《fontFamily》;background-color:《backgroundColor》;">
                <p style="font-family:《fontFamily》;">《titleButton》</p><span class="arrow-right"></span>
        </a>`
    },
    {
        id: 6,
        name: '6',
        backgroundColorDefault: '#c61818',
        colorDefault: '#ffffff',
        contents: `
        <a id="button-link" href="《URL》" target="_blank" class="button--type__6" style="color:《color》;font-family:《fontFamily》;background-color:《backgroundColor》;">
                <p style="font-family:《fontFamily》;">《titleButton》</p><span class="arrow-right"></span>
        </a>`
    },
    {
        id: 7,
        name: '7',
        backgroundColorDefault: '#3F2771',
        colorDefault: '#ffffff',
        contents: `
        <a id="button-link" href="《URL》" target="_blank" class="button--type__7" style="color:《color》;font-family:《fontFamily》;background-color:《backgroundColor》;">
                <p style="font-family:《fontFamily》;">《titleButton》</p><span class="arrow-right"></span>
        </a>`
    },
    {
        id: 8,
        name: '8',
        backgroundColorDefault: '#EFE930',
        colorDefault: '#0E1771',
        contents: `
        <a id="button-link" href="《URL》" target="_blank" class="button--type__8" style="color:《color》;font-family:《fontFamily》;background-color:《backgroundColor》;">
                <p style="font-family:《fontFamily》;">《titleButton》</p><span class="arrow-right"></span>
        </a>`
    }
]);

const LIST_STYLE_FREE_BLOCK = HANDLE_MAP_STYLE_WITH_DEFAULT([
    {
        id: 3,
        name: '3',
        contents: `<p class="content--free__block"></p>`,
        cssStyle: `
        .block_free .box--type__3 .content_editor {
            padding: 10px 20px;
        }
        .block_free .content--free__block {
            margin-top: 1rem;
        }
        `
    },
    {
        id: 4,
        name: '4',
        backgroundColorDefault: '#DEC2FF',
        contents: `<p class="content--free__block"></p>`,
        cssStyle: `
        .block_free .box--type__4 .content_editor {
            padding: 10px 20px;
        }
        .block_free .content--free__block {
            margin-top: 1rem;
        }
        `
    },
    {
        id: 5,
        name: '5',
        contents: `<p class="content--free__block"></p>`,
        cssStyle: `
        .block_free .box--type__5 .content_editor {
            padding: 10px 20px;
        }
        .block_free .content--free__block {
            margin-top: 1rem;
        }
        `
    },
    {
        id: 6,
        name: '6',
        contents: `<p class="content--free__block"></p>`,
        cssStyle: `
        .block_free .box--type__6 .content_editor {
            padding: 10px 20px;
        }
        .block_free .content--free__block {
            margin-top: 1rem;
        }
        `
    },
    {
        id: 7,
        name: '7',
        contents: `<p class="content--free__block"></p>`,
        cssStyle: `
        .block_free .box--type__7 .content_editor {
            padding: 10px 20px;
        }
        .block_free .content--free__block {
            margin-top: 1rem;
        }
        `
    },
    {
        id: 8,
        name: '8',
        contents: `<p class="content--free__block"></p>`,
        cssStyle: `
        .block_free .box--type__8 .content_editor {
            padding: 10px 20px;
        }
        .block_free .content--free__block {
            margin-top: 1rem;
        }
        `
    }
]);

export {
    LIST_STYLE_TIME,
    LIST_STYLE_PRIZE,
    LIST_STYLE_TARGET_PRODUCT,
    LIST_STYLE_APPLICATION_METHODS,
    LIST_STYLE_CONTACT,
    LIST_STYLE_BUTTON_BLOCK,
    LIST_STYLE_APPLICATION_RULE,
    LIST_STYLE_FREE_BLOCK,
    LIST_TEMPLATE_DEFAULT
};
